import { Component, Input, OnInit } from '@angular/core';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'app-archived-job-actions',
    templateUrl: './archived-job-actions.component.html',
    styleUrls: ['./archived-job-actions.component.scss']
})
export class ArchivedJobActionsComponent implements OnInit {
    @Input()
    job: ITaskModel;

    constructor() { }

    ngOnInit(): void { }

}
